// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"164":"63ecc688","214":"d070019b","254":"f9dc8f63","453":"5eabcf17","721":"045f6200","833":"99d28289","976":"99d28289"}[chunkId] + ".chunk.js";
};